import { DEV_TEAM_USER_WHITE_LIST } from "@tradingApp/constants";
import { webAppUserGet } from "@tradingApp/helpers/webApp/userGet";

export function isDevTeamUser(): boolean {
  const user = webAppUserGet();

  if (!user || !user.username) {
    return false;
  }

  return DEV_TEAM_USER_WHITE_LIST.includes(user.username);
}
